export default __webpack_public_path__ + "static/media/gitlab-icon-1-color-white-rgb.dedc9927.webp";